import { Component, effect, output, viewChild } from '@angular/core';
import { ModalComponent } from '../modal/modal.component';

@Component({
  standalone: true,
  selector: 'ct-lib-modal-wrapper',
  template: '',
  host: {
    '(click)': 'onClick($event)',
  },
  imports: [],
})
export class ModalWrapperComponent {
  onClick(event: Event) {
    event.stopPropagation();
  }

  public modal = viewChild<ModalComponent>('modal');

  public onClose = output<void>();
  public onCloseEnd = output<void>();
  public onOpen = output<void>();
  public onOpenEnd = output<void>();

  constructor() {
    effect((onCleanup) => {
      const modal = this.modal();
      if (!modal) {
        return;
      }
      const subscriptions = [
        modal.onClose.subscribe(() => {
          this.onClose.emit();
        }),
        modal.onCloseEnd.subscribe(() => {
          this.onCloseEnd.emit();
        }),
        modal.onOpen.subscribe(() => {
          this.onOpen.emit();
        }),
        modal.onOpenEnd.subscribe(() => {
          this.onOpenEnd.emit();
        }),
      ];
      onCleanup(() => {
        for (const subscription of subscriptions) {
          subscription.unsubscribe();
        }
      });
    });
  }

  open() {
    this.modal()?.open();
  }

  public close(): void {
    this.modal()?.close();
  }

  public shake(): void {
    this.modal()?.shake();
  }
}
